<h2 mat-dialog-title>Requests Submitted</h2>
<mat-dialog-content>
  <div class="progress-content">
    <p class="info-text">
      Your requests are processing. You can close this window and check progress on the "Search History" page.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onGoToHistory()">Go to Search History</button>
  <button mat-button (click)="onOk()" color="primary">OK</button>
</mat-dialog-actions>


